import React from "react";
import {Navigate} from "react-router-dom";

const isTokenValid = (): string | null => {
    return localStorage.getItem("accessToken");
};

interface Props {
    children: React.ReactNode;
}

export default function PrivateRoute({children}: Props) {
    return isTokenValid()
        ? <>{children}</>
        : <Navigate to="/login" replace/>;
}